import { render } from "./DuplicatePopup.vue?vue&type=template&id=27264e1e"
import script from "./DuplicatePopup.vue?vue&type=script&lang=js"
export * from "./DuplicatePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__